import axiosIns from '@/plugins/axios'

export default {
  getAggregations() {
    return axiosIns.get('/v2/eod_report/realtime_aggregations')
  },
  getAggregation(id, date) {
    return axiosIns.get(`/v2/eod_report/realtime_aggregations/${id}`, { params: { date } })
  },
}
